
// Status types - these are consistent across organizations
export const STATUS_TYPES = {
  PROPOSAL: 'proposal',
  LEAD: 'lead',
  USER: 'user',
  ORGANIZATION: 'organization',
  TASK: 'task',
  PLOT: 'plot',
  CONTRACT: 'contract',
  GENERAL: 'general',
  MEETING: 'meeting',
  VIEWING: 'viewing',
  EVENT: 'event',
  INVOICE: 'invoice',
  PAYMENT: 'payment',
  NOTE: 'note',
};

// Status names - these are consistent across organizations
export const STATUS_NAMES = {
  // General statuses
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',

  //Contract
  IN_CLOSURE: 'In Closure',
  SIGNED: 'Signed',
  APPLIED: 'Applied',
  REVIEW: 'Review',
  RENEWAL_REQUESTED: 'renewal-requested',
  
  // Lead statuses
  READ: 'Read',
  UNREAD: 'Unread',
  
  // Plot statuses
  VACANT: 'Vacant',
  OCCUPIED: 'Occupied',
  ARCHIVED: 'Archived',
  
  // Task statuses
  TO_DO: 'To Do',
  OVERDUE: 'Overdue',
  ON_HOLD: 'On Hold',
  DONE: 'Done',
  
  // Priority levels
  URGENT: 'Urgent',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  
  // Other statuses
  IN_REVIEW: 'In Review',
  CONFIRMED: 'Confirmed',
  UPCOMING: 'Upcoming',

  //Invoice statuses
  PAID: 'Paid',
  
  //Payment statuses
  VALIDATED: 'Validated',
};
